import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { BrowserRouter } from 'react-router';
import { Toaster } from 'react-hot-toast';
import App from './App';
import './index.css';
// Bootstrap Monaco editor to load from local npm package (not jsdelivr CDN).
// Must be imported before any component that renders Monaco.
import './config/monaco';

// Configure React Query client with sensible defaults
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes - cache data longer
      gcTime: 10 * 60 * 1000, // 10 minutes - keep unused data in cache
      retry: 1, // Reduce retries for faster failures
      refetchOnWindowFocus: false,
      refetchOnMount: true, // Refetch on mount if data is stale (default behavior)
    },
    mutations: {
      retry: 0, // Don't retry mutations
    },
  },
});

// Render the app - auth state is checked by AuthContext on mount
// Auth token is in an HttpOnly cookie on management API domain (auto-sent by browser)
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#363636',
              color: '#fff',
            },
            success: {
              iconTheme: {
                primary: '#22c55e',
                secondary: '#fff',
              },
            },
            error: {
              iconTheme: {
                primary: '#ef4444',
                secondary: '#fff',
              },
            },
          }}
        />
      </BrowserRouter>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </React.StrictMode>
);
